import { render } from "./ProfileCardInternal.vue?vue&type=template&id=b939207e&scoped=true"
import script from "./ProfileCardInternal.vue?vue&type=script&lang=js"
export * from "./ProfileCardInternal.vue?vue&type=script&lang=js"

import "./ProfileCardInternal.vue?vue&type=style&index=0&id=b939207e&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b939207e"]])

export default __exports__